// import { array, number, object } from 'yup';
// import POS from './POS';
// import { Form, Formik, FormikHelpers } from 'formik';
// import { AppDispatch, RootState } from 'src/store';
// import { useDispatch, useSelector } from 'react-redux';
// import { showToast } from 'src/utils/showToaster';
// import { setIsOpenAddDialog, setIsOpenCustomerDialog, setIsOpenTreatmentDialog } from './slice/CartSlice';
// import { useAddInvoiceMutation, useUpdateGivenChangeMutation } from './service/POSServices';
// import AddCustomerFormWrapper from './components/AddCustomerForm/AddCustomerFormWrapper';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import {
//   setIsOpenAddDialog as setIsOpenAddDialogRegister,
//   setIsCloseAddDialog,
// } from 'src/modules/OpenRegister/slice/OpenRegisterSlice';
// import OpenRegisterFormWrapper from '../OpenRegister/screens/Add/AddOpenRegisterFormWrapper';
// import CloseRegisterFormWrapper from '../OpenRegister/screens/Add/AddCloseRegisterFormWrapper';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import { useSendPdfViaEmailMutation } from '../Invoices/service/InvoicesServices';
// import TreatmentAddFormWrapper from './components/AddCustomerForm/TreatmentAddFormLayout';
// import { useState } from 'react';
// import { useAddRewardsCouponMutation, useUpdateRewardsCouponMutation } from '../RewardsCoupon/service/RewardsCouponServices';
// type Props = {};

// const POSWrapper = (props: Props) => {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   const bookingId = searchParams.get("bookingId")
// const [treatments, setTreatments] = useState<any[]>([]);
//   const { outlet } = useSelector((state: RootState) => state.auth);
//   const { isOpenCustomerDialog, isOpenTreatmentDialog, previewData } = useSelector(
//     (state: RootState) => state.cart,
//   );
//   const { isOpenAddDialog, isCloseAddDialog } = useSelector(
//     (state: RootState) => state?.register,
//   );

//   const dispatch = useDispatch<AppDispatch>();
//   const [addInvoice] = useAddInvoiceMutation();
//   const [updateGivenChange] = useUpdateGivenChangeMutation();
// const [addRewardsCoupon] = useAddRewardsCouponMutation();
// const [updateRewardsCoupon] = useUpdateRewardsCouponMutation();
//   const initialValues = {
//     customer: null,
//     items: [],
//     couponCode: '',
//     shippingCharges: 0,
//     discount: null,
//   subtotal: '0.00',
//   discountAmount: '0.00',
//   finalAmount: '0.00',
//     amountReceived: [
//       {
//         paymentModeId: '',
//         amount: 0,
//         txnNumber: ''
//       },
//     ],
//     giftCardCode: '',
//     promotionCoupanCode: '',
//     rewardCoupan: '',
//     useLoyaltyPoints: false,
//     useCashBackAmount: false,
//     usedCashBackAmount: 0,
//     referralCode: '',
//     notes: '',
//   };
//   // const validationSchema = object().shape({
//   //   customer: object().required('Please select customer').nullable(),
//   //   amountReceived: array().of(
//   //     object().shape({
//   //       paymentModeId: object().required('Payment mode is required'),
//   //       amount: number()
//   //         .required('Amount is required')
//   //         .typeError('Amount must be a number')
//   //         .min(0, 'Amount must be positive')
//   //         .test('totalReceived', '', function (value, context) {
//   //           const totalReceived =
//   //             context?.options?.context?.amountReceived?.reduce(
//   //               (sum: number, item: any) => sum + (Number(item.amount) || 0),
//   //               0,
//   //             );
//   //           return (
//   //             totalReceived <= previewData?.invoiceData?.totalAmount.toFixed(2)
//   //           );
//   //         }),
//   //     }),
//   //   ),
//   // });
//   const validationSchema = object().shape({
//     customer: object().required('Please select customer').nullable(),
//     amountReceived: array().of(
//       object().shape({
//         paymentModeId: object().required('Payment mode is required'),
//         amount: number()
//           .required('Amount is required')
//           .typeError('Amount must be a number')
//           .min(0, 'Amount must be positive'),
//       }),
//     ),
//   });

//   // const handleSubmit = (
//   //   values: any,
//   //   { resetForm, setSubmitting }: FormikHelpers<any>,
//   // ) => {
//   //   let formattedValues = {
//   //     customerId: values?.customer?._id,
//   //     items: values?.items?.map((item: any) => {
//   //       return {
//   //         itemId: item?._id,
//   //         quantity: item?.quantity,
//   //         itemType: item?.type,
//   //       };
//   //     }),
//   //     couponCode: values?.couponCode,
//   //     shippingCharges: values?.shippingCharges || 0,
//   //     amountReceived: values?.amountReceived?.map((el: any) => {
//   //       return {
//   //         paymentModeId: el?.paymentModeId?._id,
//   //         amount: el?.amount,
//   //       };
//   //     }),
//   //     giftCardCode: values?.giftCardCode,
//   //     useLoyaltyPoints: values?.useLoyaltyPoints,
//   //     referralCode: '',
//   //     outletId: (outlet as any)?._id,
//   //     notes: values?.notes,
//   //     useCashBackAmount: values?.useCashBackAmount,
//   //     usedCashBackAmount: values?.usedCashBackAmount,
//   //     bookingId: bookingId
//   //   };
//   //   addInvoice(formattedValues).then((res: any) => {
//   //     if (res?.error) {
//   //       showToast('error', res?.error?.data?.message);
//   //     } else {
//   //       if (res?.data?.status) {
//   //         showToast('success', res?.data?.message);
//   //         resetForm();
//   //         dispatch(setIsOpenAddDialog(false));
//   //         navigate(`/invoice/receipt/${res?.data?.data?._id}`);
//   //       } else {
//   //         showToast('error', res?.data?.message);
//   //       }
//   //     }
//   //     setSubmitting(false);
//   //   });
//   // };

//   // new code -----
//   const [sendPdfViaEmail, { isLoading }] = useSendPdfViaEmailMutation();

//   const handleSendEmail = async (invoiceId: any) => {
//     console.log('---- handle send email')
//     const receiptElement = document.querySelector('.receipt-print');
//     console.log('---- handle send emailssss')
//     if (!receiptElement) return;

//     try {
//       const canvas = await html2canvas(receiptElement as HTMLElement, { scale: 2 });
//       const imgData = canvas.toDataURL('image/png', 0.6);

//       const pdf = new jsPDF('p', 'mm', 'a4');
//       const pageWidth = 210;
//       const pageHeight = 297;
//       const padding = 10;
//       const imgWidth = pageWidth - 2 * padding;
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;

//       let heightLeft = imgHeight;
//       let position = 0;

//       // First page
//       pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight - 2 * padding;

//       while (heightLeft > 0) {
//         position = heightLeft - imgHeight - 10 - padding;
//         pdf.addPage();
//         pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight);
//         heightLeft -= pageHeight - 10 - padding;
//       }

//       // Create blob & formData
//       const pdfBlob = pdf.output('blob');
//       const formData = new FormData();
//       formData.append('file', pdfBlob, 'invoice.pdf');
//       formData.append('emailBody', 'Dear Customer,\n\nThank you for your purchase. Please find the attached invoice.\n\nBest regards,\nYour Company Name');

//       // Send to backend
//       const res = await sendPdfViaEmail({
//         invoiceId, // ✅ Make sure this is a valid MongoDB ID
//         body: formData,
//       });

//       if ('error' in res) {
//         showToast('error', 'Failed to send email');
//       } else {
//         showToast('success', res.data?.message || 'Invoice emailed successfully');
//       }
//     } catch (err) {
//       console.error(err);
//       showToast('error', 'Something went wrong while generating or sending the PDF');
//     }
//   };

//   const validateBooking = (data: any) => {
//     const {
//       giftCardCode,
//       referralCode,
//       promotionCoupanCode,
//       amountReceived,
//     } = data;

//     // console.log('-----data', data)
//     // 1️⃣ Gift Card validation
//     if (giftCardCode && giftCardCode.trim() !== "") {
//       const hasGiftCardPayment = amountReceived?.some(
//         (p: any) =>
//           p.paymentModeId === "6895c88c6dff463d0dcb7a72"
//       );

//       if (!hasGiftCardPayment) {
//         return "If you are using a gift card, you must select ,,,gift card,,, as the payment mode and enter the amount.";
//       }
//     }

//     // 2️⃣ Promo / Referral validation
//     if (
//       (referralCode && referralCode.trim() !== "") ||
//       (promotionCoupanCode && promotionCoupanCode.trim() !== "")
//     ) {
//       const hasPromoPayment = amountReceived?.some(
//         (p: any) =>
//           p.paymentModeId === "67b73e8aceeeba3a8b3444fe"
//       );

//       if (!hasPromoPayment) {
//         return "A referral or promotion code has been applied. Please select ,,,promo,,, as the payment mode and enter the corresponding amount.";
//       }
//     }

//     return null; // ✅ valid
//   };
//   //------------------- end new code


//   const waitForElement = (
//   selector: string,
//   callback: () => void,
//   timeout = 10000
// ) => {
//   const start = Date.now();

//   const interval = setInterval(() => {
//     const element = document.querySelector(selector);

//     if (element) {
//       clearInterval(interval);
//       callback();
//     }

//     if (Date.now() - start > timeout) {
//       clearInterval(interval);
//       console.error("Element not found within timeout");
//     }
//   }, 100);
// };

// const handleSubmit = async (
//   values: any,
//   { resetForm, setSubmitting }: FormikHelpers<any>,
// ) => {
//   // ============================================================
//   // ✅ Calculate discounted values for backend
//   // ============================================================
//   const subtotal =
//     Number(previewData?.invoiceData?.subtotal) ||
//     Number(previewData?.invoiceData?.totalAmount) ||
//     values?.items?.reduce(
//       (sum: number, item: any) =>
//         sum + Number(item.sellingPrice || 0) * Number(item.quantity || 0),
//       0
//     ) ||
//     0;

//   // Discount from Formik (values.discount = { type, value } or null)
//   const discount = values?.discount || null;
//   let discountAmount = 0;
//   if (discount && Number(discount.value) > 0) {
//     if (discount.type === "FLAT") {
//       discountAmount = Math.min(Number(discount.value), subtotal);
//     } else if (discount.type === "PERCENTAGE") {
//       discountAmount = Math.min(
//         (subtotal * Math.min(Number(discount.value), 100)) / 100,
//         subtotal
//       );
//     }
//   }
//   discountAmount = parseFloat(discountAmount.toFixed(2));
//   const finalAmount = parseFloat(
//     Math.max(0, subtotal - discountAmount).toFixed(2)
//   );

//   // ✅ formattedValues with discount + derived fields
//   let formattedValues = {
//     customerId: values?.customer?._id,
//     items: values?.items?.map((item: any) => ({
//       itemId: item?._id,
//       quantity: item?.quantity,
//       itemType: item?.type,
//     })),
//     couponCode: values?.couponCode || "",
//     shippingCharges: values?.shippingCharges || 0,
//     amountReceived: values?.amountReceived?.map((el: any) => ({
//       paymentModeId: el?.paymentModeId?._id || el?.paymentModeId,
//       amount: Number(el?.amount) || 0,
//       txnNumber: el?.txnNumber || "",
//     })),
//     giftCardCode: values?.giftCardCode || "",
//     promotionCoupanCode: values?.promotionCoupanCode || "",
//     rewardCoupan: values?.rewardCoupan || "",
//     useLoyaltyPoints: values?.useLoyaltyPoints || false,
//     referralCode: "",
//     outletId: (outlet as any)?._id,
//     notes: values?.notes || "",
//     useCashBackAmount: values?.useCashBackAmount || false,
//     usedCashBackAmount: values?.usedCashBackAmount || 0,
//     bookingId: bookingId,
//     extraServices: treatments,

//     // ✅✅✅ DISCOUNT FIELDS — YEH MISSING THE
//     discount: discount,
//     subtotal: parseFloat(subtotal.toFixed(2)),
//     discountAmount: discountAmount,
//     finalAmount: finalAmount,
//   };

//   // 🚨 DEBUG — confirm karo discount bhej raha hai
//   console.log("🚨🚨🚨 [POSWrapper] SENDING TO BACKEND:");
//   console.log("  discount:", formattedValues.discount);
//   console.log("  subtotal:", formattedValues.subtotal);
//   console.log("  discountAmount:", formattedValues.discountAmount);
//   console.log("  finalAmount:", formattedValues.finalAmount);
//   console.log("  amountReceived:", formattedValues.amountReceived);
//   console.log("  FULL PAYLOAD:", JSON.stringify(formattedValues, null, 2));

//   const error = validateBooking(formattedValues);

//   if (error) {
//     showToast("error", error);
//     setSubmitting(false);
//     return;
//   }

//   setSubmitting(true);

//   try {
//     const res: any = await addInvoice(formattedValues);

//     if (res?.error) {
//       showToast("error", res?.error?.data?.message);
//     } else if (res?.data?.status) {
//       const createdInvoiceId = res?.data?.data?._id;

//       // ✅ Use BACKEND response values (source of truth)
//       const backendInvoice = res?.data?.data;
//       const totalAmount = Number(
//         backendInvoice?.totalAmount ||
//         previewData?.invoiceData?.totalAmount ||
//         0
//       );

//       const totalReceived = values?.amountReceived?.reduce(
//         (sum: number, item: any) => sum + (Number(item.amount) || 0),
//         0
//       );

//       const givenChange = Number((totalReceived - totalAmount).toFixed(2));

//       if (givenChange > 0 && createdInvoiceId) {
//         const givenChangePayload = {
//           invoiceId: createdInvoiceId,
//           value: givenChange,
//         };
//         await updateGivenChange(givenChangePayload);
//       }

//       showToast("success", "Invoice Create Successfully");
//       resetForm();
//       dispatch(setIsOpenAddDialog(false));
//       navigate(`/invoice/receipt/${createdInvoiceId}`, {
//         state: {
//           autoSendEmail: true,
//         },
//       });
//     } else {
//       showToast("error", res?.data?.message);
//     }
//   } catch (error) {
//     showToast("error", "Something went wrong while submitting the invoice.");
//   } finally {
//     setSubmitting(false);
//   }
// };

// //   const handleSubmit = async (
// //     values: any,
// //     { resetForm, setSubmitting }: FormikHelpers<any>,
// //   ) => {


// //     let formattedValues = {
// //       customerId: values?.customer?._id,
// //       items: values?.items?.map((item: any) => ({
// //         itemId: item?._id,
// //         quantity: item?.quantity,
// //         itemType: item?.type,
// //       })),
// //       couponCode: values?.couponCode,
// //       shippingCharges: values?.shippingCharges || 0,
// //       amountReceived: values?.amountReceived?.map((el: any) => ({
// //         paymentModeId: el?.paymentModeId?._id,
// //         amount: el?.amount,
// //         txnNumber: el?.txnNumber
// //       })),
// //       giftCardCode: values?.giftCardCode,
// //       promotionCoupanCode: values?.promotionCoupanCode,
// //       rewardCoupan: values?.rewardCoupan,
// //       useLoyaltyPoints: values?.useLoyaltyPoints,
// //       referralCode: '',
// //       outletId: (outlet as any)?._id,
// //       notes: values?.notes,
// //       useCashBackAmount: values?.useCashBackAmount,
// //       usedCashBackAmount: values?.usedCashBackAmount,
// //       bookingId: bookingId,
// //       extraServices:treatments
// //     };

// //     const error = validateBooking(formattedValues);

// //     if (error) {
// //       showToast('error', error);
// //       setSubmitting(false)
// //       return;
// //     }

// //     setSubmitting(true);

// //     try {
// //       // console.log("4444444444444440000000000")
// //       const res: any = await addInvoice(formattedValues);

// //       if (res?.error) {
// //         showToast('error', res?.error?.data?.message);
// //       } else if (res?.data?.status) {

// //         const createdInvoiceId = res?.data?.data?._id;

// //         const totalAmount = previewData?.invoiceData?.totalAmount || 0;
// //         const totalReceived = values?.amountReceived?.reduce(
// //           (sum: number, item: any) => sum + (Number(item.amount) || 0),
// //           0,
// //         );

// //         const givenChange = totalReceived - totalAmount;

// //         // If givenChange is positive, call the update API
// //         if (givenChange > 0 && createdInvoiceId) {
// //           const givenChangePayload = {
// //             invoiceId: createdInvoiceId,
// //             value: givenChange,
// //           };
// //           // console.log("555555555540000000000")
// //           await updateGivenChange(givenChangePayload);
// //         }

// //         showToast('success', 'Invoice Create Successfuly');
// //         resetForm();
// //         dispatch(setIsOpenAddDialog(false));
// //         // navigate(`/invoice/receipt/${createdInvoiceId}`);
// //      navigate(`/invoice/receipt/${createdInvoiceId}`, {
// //   state: {
// //     autoSendEmail: true,
// //   },
// // });
// //         //--------
// //         // Then after rendering
// //         // setTimeout(() => {
// //         //   handleSendEmail(createdInvoiceId);
// //         // }, 1000);
// //         //--------
// //       } else {
// //         showToast('error', res?.data?.message);
// //       }
// //     } catch (error) {
// //       // console.error("Submit Error:", error);
// //       showToast('error', 'Something went wrong while submitting the invoice.');
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

//  const handleTreatmentSave = (data: any) => {
//   // console.log("Parent received:", data);

//   setTreatments((prev: any) => [...prev, data]);
// };

//   return (
//     <div>
//       <Formik
//         initialValues={initialValues}
//         onSubmit={handleSubmit}
//         validationSchema={validationSchema}
//         enableReinitialize
//       >
//         {(formikProps) => (
//           <Form>
//             <POS formikProps={formikProps} />
//           </Form>
//         )}
//       </Formik>

//       {isOpenCustomerDialog && (
//         <AddCustomerFormWrapper
//           onClose={() => dispatch(setIsOpenCustomerDialog(false))}
//         />
//       )}

//       {isOpenTreatmentDialog && (
//         <TreatmentAddFormWrapper
//           onClose={() => dispatch(setIsOpenTreatmentDialog(false))}
//           onSave={handleTreatmentSave}
//         />
//       )}

//       {isOpenAddDialog && (
//         <OpenRegisterFormWrapper
//           onClose={() => dispatch(setIsOpenAddDialogRegister(false))}
//           opningData={null}
//         />
//       )}
//       {isCloseAddDialog && (
//         <CloseRegisterFormWrapper
//           onClose={() => dispatch(setIsCloseAddDialog(false))}
//         />
//       )}
//     </div>
//   );
// };

// export default POSWrapper;


import { array, number, object } from 'yup';
import POS from './POS';
import { Form, Formik, FormikHelpers } from 'formik';
import { AppDispatch, RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from 'src/utils/showToaster';
import { setIsOpenAddDialog, setIsOpenCustomerDialog, setIsOpenTreatmentDialog } from './slice/CartSlice';
import { useAddInvoiceMutation, useUpdateGivenChangeMutation } from './service/POSServices';
import AddCustomerFormWrapper from './components/AddCustomerForm/AddCustomerFormWrapper';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  setIsOpenAddDialog as setIsOpenAddDialogRegister,
  setIsCloseAddDialog,
} from 'src/modules/OpenRegister/slice/OpenRegisterSlice';
import OpenRegisterFormWrapper from '../OpenRegister/screens/Add/AddOpenRegisterFormWrapper';
import CloseRegisterFormWrapper from '../OpenRegister/screens/Add/AddCloseRegisterFormWrapper';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useSendPdfViaEmailMutation } from '../Invoices/service/InvoicesServices';
import TreatmentAddFormWrapper from './components/AddCustomerForm/TreatmentAddFormLayout';
import { useState } from 'react';
import { useAddRewardsCouponMutation, useUpdateRewardsCouponMutation } from '../RewardsCoupon/service/RewardsCouponServices';

type Props = {};

const POSWrapper = (props: Props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("bookingId");
  const [treatments, setTreatments] = useState<any[]>([]);
  const { outlet } = useSelector((state: RootState) => state.auth);
  const { isOpenCustomerDialog, isOpenTreatmentDialog, previewData } = useSelector(
    (state: RootState) => state.cart,
  );
  const { isOpenAddDialog, isCloseAddDialog } = useSelector(
    (state: RootState) => state?.register,
  );

  const dispatch = useDispatch<AppDispatch>();
  const [addInvoice] = useAddInvoiceMutation();
  const [updateGivenChange] = useUpdateGivenChangeMutation();
  const [addRewardsCoupon] = useAddRewardsCouponMutation();
  const [updateRewardsCoupon] = useUpdateRewardsCouponMutation();

  const initialValues = {
    customer: null,
    items: [],
    couponCode: '',
    shippingCharges: 0,
    discount: null,
    subtotal: '0.00',
    discountAmount: '0.00',
    finalAmount: '0.00',
    amountReceived: [
      { paymentModeId: '', amount: 0, txnNumber: '' },
    ],
    giftCardCode: '',
    promotionCoupanCode: '',
    rewardCoupan: '',
    useLoyaltyPoints: false,
    useCashBackAmount: false,
    usedCashBackAmount: 0,
    referralCode: '',
    notes: '',
  };

  const validationSchema = object().shape({
    customer: object().required('Please select customer').nullable(),
    amountReceived: array().of(
      object().shape({
        paymentModeId: object().required('Payment mode is required'),
        amount: number()
          .required('Amount is required')
          .typeError('Amount must be a number')
          .min(0, 'Amount must be positive'),
      }),
    ),
  });

  const [sendPdfViaEmail, { isLoading }] = useSendPdfViaEmailMutation();

  const handleSendEmail = async (invoiceId: any) => {
    // ... existing
  };

   const validateBooking = (data: any) => {
    const {
      giftCardCode,
      referralCode,
      promotionCoupanCode,
      amountReceived,
    } = data;

    // console.log('-----data', data)
    // 1️⃣ Gift Card validation
    if (giftCardCode && giftCardCode.trim() !== "") {
      const hasGiftCardPayment = amountReceived?.some(
        (p: any) =>
          p.paymentModeId === "6895c88c6dff463d0dcb7a72"
      );

      if (!hasGiftCardPayment) {
        return "If you are using a gift card, you must select ,,,gift card,,, as the payment mode and enter the amount.";
      }
    }

    // 2️⃣ Promo / Referral validation
    if (
      (referralCode && referralCode.trim() !== "") ||
      (promotionCoupanCode && promotionCoupanCode.trim() !== "")
    ) {
      const hasPromoPayment = amountReceived?.some(
        (p: any) =>
          p.paymentModeId === "67b73e8aceeeba3a8b3444fe"
      );

      if (!hasPromoPayment) {
        return "A referral or promotion code has been applied. Please select ,,,promo,,, as the payment mode and enter the corresponding amount.";
      }
    }

    return null; // ✅ valid
  };

  

  // ✅ Rollback helper for gift card coupons
  const rollbackGiftCardCoupons = async (couponIds: string[]) => {
    for (const couponId of couponIds) {
      try {
        await updateRewardsCoupon({
          rewardsCouponId: couponId,
          body: { isDeleted: true, isActive: false },
        }).unwrap();
        console.log(`✅ Rolled back coupon: ${couponId}`);
      } catch (err) {
        console.warn(`⚠️ Failed to rollback coupon ${couponId}:`, err);
      }
    }
  };

  const handleSubmit = async (
    values: any,
    { resetForm, setSubmitting }: FormikHelpers<any>,
  ) => {
    // ============================================================
    // 1. Calculate subtotal + discount values
    // ============================================================
    const subtotal =
      Number(previewData?.invoiceData?.subtotal) ||
      Number(previewData?.invoiceData?.totalAmount) ||
      values?.items?.reduce(
        (sum: number, item: any) =>
          sum + Number(item.sellingPrice || 0) * Number(item.quantity || 0),
        0
      ) ||
      0;

    const discount = values?.discount || null;
    let discountAmount = 0;
    if (discount && Number(discount.value) > 0) {
      if (discount.type === "FLAT") {
        discountAmount = Math.min(Number(discount.value), subtotal);
      } else if (discount.type === "PERCENTAGE") {
        discountAmount = Math.min(
          (subtotal * Math.min(Number(discount.value), 100)) / 100,
          subtotal
        );
      }
    }
    discountAmount = parseFloat(discountAmount.toFixed(2));
    const finalAmount = parseFloat(
      Math.max(0, subtotal - discountAmount).toFixed(2)
    );

    // ============================================================
    // 2. Detect gift card items
    // ============================================================
    const giftCardItems = (values?.items || []).filter(
      (i: any) => i?.type === 'SERVICE_GIFTCARD'
    );

    console.log("🎁 [POSWrapper] Gift card items:", giftCardItems.length);

    // Track created coupons for rollback
    const createdCoupons: { couponId: string; originalItemId: string }[] = [];

    setSubmitting(true);

    try {
      // ============================================================
      // 3. Create gift card coupons FIRST
      // ============================================================
      for (const item of giftCardItems) {
        const today = new Date();
        const oneYearLater = new Date();
        oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

        const couponPayload = {
          couponType: 'SERVICE_GIFTCARD',
          couponCode: item.giftCardCode,
          rewardName: `Gift Card - ${item.giftCardCode}`,
          giftCardAmount: Number(item.giftCardAmount || item.sellingPrice),
          balanceAmount: Number(item.giftCardAmount || item.sellingPrice),
          rewardType: 'AMOUNT',
          rewardValue: 0,
          rewardsPoint: 0,
          minimumSpend: 0,
          maximumDiscount: 0,
          serviceId: [item.originalServiceId || item._id],
          isActive: true,
          description: `Gift card for ${item.itemName}`,
          startTime: '00:00',
          endTime: '23:59',
          validFrom: today,
          validTill: oneYearLater,
          validDays: [
            'Monday', 'Tuesday', 'Wednesday', 'Thursday',
            'Friday', 'Saturday', 'Sunday',
          ],
        };

        console.log("🎁 [POSWrapper] Creating coupon:", couponPayload.couponCode);

        const couponRes: any = await addRewardsCoupon(couponPayload).unwrap();

        const couponId =
          couponRes?.data?._id ||
          couponRes?.data?.id ||
          couponRes?._id;

        if (!couponId) {
          throw new Error(
            `Gift card create response me ID nahi mili (${item.giftCardCode})`
          );
        }

        createdCoupons.push({
          couponId,
          originalItemId: item._id,
        });

        console.log(`✅ [POSWrapper] Coupon created: ${couponId}`);
      }

      // ============================================================
      // 4. Build couponId map (itemId → couponId)
      // ============================================================
      const couponMap = new Map(
        createdCoupons.map((c) => [c.originalItemId, c.couponId])
      );

      // ============================================================
      // 5. Build invoice items with couponId for gift cards
      // ============================================================
      // const invoiceItems = (values?.items || []).map((item: any) => {
      //   const isGiftCard = item?.type === 'SERVICE_GIFTCARD';
      //   const mappedId = isGiftCard
      //     ? couponMap.get(item._id) || item._id
      //     : item._id;

      //   return {
      //     itemId: mappedId,
      //     quantity: item?.quantity,
      //     itemType: item?.type,
      //   };
      // });

      const invoiceItems = (values?.items || []).map((item: any) => {
        const isGiftCard = item?.type === 'SERVICE_GIFTCARD';
        const mappedId = isGiftCard
          ? couponMap.get(item._id) || item._id
          : item._id;

        return {
          itemId: mappedId,
          quantity: item?.quantity,
          itemType: item?.type,
          
          // 🔥 YEH LINES ADD KAREIN (Backend ko naya amount bhejne ke liye)
          sellingPrice: Number(item?.sellingPrice || 0),
          ...(isGiftCard && {
            isTempGiftCard: false,
            sellingPrice: Number(item.giftCardAmount || item.sellingPrice || 0)
          }),
        };
      });

      // ============================================================
      // 6. Build formatted payload
      // ============================================================
      let formattedValues = {
        customerId: values?.customer?._id,
        items: invoiceItems,
        couponCode: values?.couponCode || "",
        shippingCharges: values?.shippingCharges || 0,
        amountReceived: values?.amountReceived?.map((el: any) => ({
          paymentModeId: el?.paymentModeId?._id || el?.paymentModeId,
          amount: Number(el?.amount) || 0,
          txnNumber: el?.txnNumber || "",
        })),
        giftCardCode: values?.giftCardCode || "",
        promotionCoupanCode: values?.promotionCoupanCode || "",
        rewardCoupan: values?.rewardCoupan || "",
        useLoyaltyPoints: values?.useLoyaltyPoints || false,
        referralCode: "",
        outletId: (outlet as any)?._id,
        notes: values?.notes || "",
        useCashBackAmount: values?.useCashBackAmount || false,
        usedCashBackAmount: values?.usedCashBackAmount || 0,
        bookingId: bookingId,
        extraServices: treatments,
        discount: discount,
        subtotal: parseFloat(subtotal.toFixed(2)),
        discountAmount: discountAmount,
        finalAmount: finalAmount,
      };

      console.log("🚨 [POSWrapper] Sending to backend:", JSON.stringify(formattedValues, null, 2));

      // ============================================================
      // 7. Pre-submit validation
      // ============================================================
      const error = validateBooking(formattedValues);

      if (error) {
        await rollbackGiftCardCoupons(createdCoupons.map((c) => c.couponId));
        showToast("error", error);
        setSubmitting(false);
        return;
      }

      // ============================================================
      // 8. Create invoice
      // ============================================================
      const res: any = await addInvoice(formattedValues);

      if (res?.error) {
        await rollbackGiftCardCoupons(createdCoupons.map((c) => c.couponId));
        showToast("error", res?.error?.data?.message || "Invoice creation failed");
        setSubmitting(false);
        return;
      }

      if (!res?.data?.status) {
        await rollbackGiftCardCoupons(createdCoupons.map((c) => c.couponId));
        showToast("error", res?.data?.message || "Invoice creation failed");
        setSubmitting(false);
        return;
      }

      // ============================================================
      // 9. Success — proceed
      // ============================================================
      const createdInvoiceId = res?.data?.data?._id;
      const backendInvoice = res?.data?.data;
      const totalAmount = Number(
        backendInvoice?.totalAmount ||
        previewData?.invoiceData?.totalAmount ||
        0
      );

      const totalReceived = values?.amountReceived?.reduce(
        (sum: number, item: any) => sum + (Number(item.amount) || 0),
        0
      );

      const givenChange = Number((totalReceived - totalAmount).toFixed(2));

      if (givenChange > 0 && createdInvoiceId) {
        const givenChangePayload = {
          invoiceId: createdInvoiceId,
          value: givenChange,
        };
        await updateGivenChange(givenChangePayload);
      }

      showToast("success", "Invoice created successfully");
      resetForm();
      dispatch(setIsOpenAddDialog(false));
      navigate(`/invoice/receipt/${createdInvoiceId}`, {
        state: { autoSendEmail: true },
      });
    } catch (error: any) {
      console.error("❌ [POSWrapper] Error:", error);

      // Rollback on ANY error
      if (createdCoupons.length > 0) {
        await rollbackGiftCardCoupons(createdCoupons.map((c) => c.couponId));
      }

      const errorMessage =
        error?.data?.message ||
        error?.message ||
        "Something went wrong while submitting the invoice.";

      showToast("error", errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  const handleTreatmentSave = (data: any) => {
    setTreatments((prev: any) => [...prev, data]);
  };

 return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            <POS formikProps={formikProps} />
          </Form>
        )}
      </Formik>

      {isOpenCustomerDialog && (
        <AddCustomerFormWrapper
          onClose={() => dispatch(setIsOpenCustomerDialog(false))}
        />
      )}

      {isOpenTreatmentDialog && (
        <TreatmentAddFormWrapper
          onClose={() => dispatch(setIsOpenTreatmentDialog(false))}
          onSave={handleTreatmentSave}
        />
      )}

      {isOpenAddDialog && (
        <OpenRegisterFormWrapper
          onClose={() => dispatch(setIsOpenAddDialogRegister(false))}
          opningData={null}
        />
      )}
      {isCloseAddDialog && (
        <CloseRegisterFormWrapper
          onClose={() => dispatch(setIsCloseAddDialog(false))}
        />
      )}
    </div>
  );
};

export default POSWrapper;